module.exports = __webpack_public_path__ + "static/img/paillier-large-icon.f8af3053.png";